<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <h3 class="font-medium">Aprobar y compartir agenda</h3>

      <p class="text-sm mt-2 text-content-400">
        Comparte el link de la agenda (Google Calendar) para que el cliente reserve su horario.
      </p>

      <form @submit.prevent="confirm" class="mt-4">
        <div class="flex flex-col w-full">
          <label for="booking_url">Link de la agenda (Google Calendar)</label>
          <input
            id="booking_url"
            type="url"
            v-model="form.booking_url"
            placeholder="https://calendar.google.com/..."
            required
          />
          <validation-errors :errors="errorFor('booking_url')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="message">Mensaje para el cliente (opcional)</label>
          <textarea id="message" class="h-24" v-model="form.message"></textarea>
          <validation-errors :errors="errorFor('message')"></validation-errors>
        </div>

        <primary-button class="w-auto mt-4" :loading="loading" type="submit">
          Aprobar
        </primary-button>

        <button v-if="!loading" class="link mt-4 mx-auto w-full" @click.prevent="close">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
export default {
  name: "Approve Appointment Modal",

  mixins: [validationErrors],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        booking_url: "",
        message: "",
      },
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },

    confirm() {
      this.errors = {};
      if (!this.form.booking_url) {
        this.errors["booking_url"] = ["Campo requerido"];
        return;
      }
      this.$emit("confirm", {
        booking_url: this.form.booking_url,
        message: this.form.message || null,
      });
    },
  },
};
</script>
